import React, {memo} from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

/* Components */
import HbImageView from '../../../../../../components/HbImage/view/HbImageView'

/* Styles */
import s from './delivery-options-content.scss'

const DELIVERY_OPTIONS_TYPE = {
  EXPRESS_DELIVERY: 'ExpressDelivery',
  NEXTDAY_DELIVERY: 'NextDayDelivery',
  PEACE_OF_MIND: 'PeaceOfMind',
  STANDARD: 'StandardDelivery',
  SCHEDULED_SAME_DAY_DELIVERY: 'ScheduledSameDayDelivery'
}

const DeliveryOptionsContent = memo(({
  dueDate,
  hasFasterMerchant,
  location,
}) => {
  if (dueDate?.deliveryOptions?.length === 0) {
    return null
  }

  return dueDate?.deliveryOptions?.map((option, index) => {
    let isPeaceOfMind = option?.type === DELIVERY_OPTIONS_TYPE.PEACE_OF_MIND
    let premiumText = option?.type === DELIVERY_OPTIONS_TYPE.SCHEDULED_SAME_DAY_DELIVERY

    return (
      <div
        className={cx(s.root, (dueDate?.deliveryOptions?.length > 1 || hasFasterMerchant) && s.hasDivider)}
        key={index}>
        <div className={cx(s.container)}>
          <div className={s.content}>
            <div className={s.textContainer}>
              <img className={s.optionIcon} src={dueDate?.basketDeliveryIcon} aria-hidden/>
              <div
                className={s.text}
                dangerouslySetInnerHTML={{__html: option?.text}}/>
            </div>
            <div className={s.optionBadge}>
              <span className={s.optionName}>{option?.rawOptionName || option?.optionName}</span>
            </div>
          </div>
          <div className={s.image} aria-hidden>
            <HbImageView
              className={s.icon}
              webpSupport={false}
              shouldLoadEagerly={false}
              image={{
                src: option?.imageUrl
              }}/>
          </div>
        </div>
        {
          premiumText &&
          <div className={s.premiumInformation}>
            <div>Teslimat ücreti <b>{option?.rawCargoPrice}</b></div>
            <img
              src={'https://images.hepsiburada.net/loyalty/premium/prod/PartnerCampaign/grouppng-8hzdr8cw48j7.png'}/>
            <span>{'`a ücretsiz'}</span>
          </div>
        }
        {
          isPeaceOfMind && option?.infoList && location &&
          option?.infoList?.map((option, index) => {
            return (
              <div key={index} className={s.infoList}>
                <HbImageView
                  className={s.icon}
                  webpSupport={false}
                  shouldLoadEagerly={false}
                  image={{
                    src: option?.iconUrl
                  }}/>
                <div className={s.description}>{option?.description}</div>
              </div>
            )
          })
        }
      </div>
    )
  })
})

DeliveryOptionsContent.propTypes = {
  isMobile: PropTypes.bool,
  onClick: PropTypes.func
}

export default DeliveryOptionsContent
